import { Wizard } from '../../../components/Wizard/Wizard';
import { ResetPasswordRedesign } from '../redesign-components/ResetPasswordRedesign/ResetPasswordRedesign';
import { ResetPasswordSuccessRedesign } from '../redesign-components/ResetPasswordSuccessRedesign/ResetPasswordSuccessRedesign';

import { authWizardWrapperStyle } from './constants';
import styles from './RedesignWizard.module.scss';

const STEPS = [ResetPasswordRedesign, ResetPasswordSuccessRedesign];

export default function ResetPasswordWizard() {
  return (
    <Wizard
      classNameSteps={styles.redesignFlowSteps}
      classNameStepWrapper={styles.redesignFlowStepWrapper}
      steps={STEPS}
      wrapperStyle={authWizardWrapperStyle}
    />
  );
}
